var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('BfInput',{attrs:{"label":"Nombre","data-key":"nombre","value":_vm.data.nombre,"edit-mode":_vm.editing,"errors":_vm.errors},on:{"update":_vm.updateForm}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }